define('models/auth',["jQuery", "T1", "T1Model"], function ($, T1, T1Model) {
  var Auth = T1Model.extend({
    user: "",
    password: ""
  });
  T1.Models.Auth = Auth;
  return Auth;
});
